import { render, staticRenderFns } from "./FollowingButton.vue?vue&type=template&id=54d425ba&scoped=true&"
import script from "./FollowingButton.vue?vue&type=script&lang=js&"
export * from "./FollowingButton.vue?vue&type=script&lang=js&"
import style0 from "./FollowingButton.vue?vue&type=style&index=0&id=54d425ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d425ba",
  null
  
)

export default component.exports